export default __webpack_public_path__ + "static/media/zvonimir_mlinaric.375a6368.jpg";